import React from "react";
import styles from "./bar.module.scss";

export const BarProgressHandle = ({ progressPoint, onMouseDown }) => {
  return (
    <polygon
      className={styles.barHandle}
      points={progressPoint}
      onMouseDown={onMouseDown}
    />
  );
};
